import { IonCol, IonGrid, IonIcon, IonRow } from "@ionic/react";
import React from "react";

import InformationSlider from "../Information/InformationSlider";
import LoginForm from "./LoginForm";

import "./login.css";

interface LoginProps {
  onLogoClick?: (e: React.MouseEvent<any> | React.TouchEvent<any>) => void;
  apiUrl?: string;
}

class Login extends React.Component<LoginProps> {
  render() {
    const { onLogoClick, apiUrl } = this.props;

    return (
      <>
        <IonGrid>
          <IonRow className="ion-justify-content-center">
            <IonCol
              sizeSm="10"
              sizeMd="8"
              sizeLg="5"
              sizeXl="3"
              className="ion-justify-content-center"
            >
              <IonIcon
                className="app-logo ion-text-center"
                src="assets/img/logo.svg"
                title="Byggkeramikrådet"
                onClick={onLogoClick}
                onTouchEnd={onLogoClick}
                data-easter-egg
              ></IonIcon>

              <LoginForm />
            </IonCol>
          </IonRow>
        </IonGrid>

        <InformationSlider />
      </>
    );
  }
}

export default Login;
